export default "__VITE_ASSET__Qwmc6$zD__"